export const REQUESTED_SECURITY_OPERATIONAL_CONSENT =
  'REQUESTED_SECURITY_OPERATIONAL_CONSENT';
export const requestedSecurityOperationalConsent = () => ({
  type: REQUESTED_SECURITY_OPERATIONAL_CONSENT
});

export const RECEIVED_SECURITY_OPERATIONAL_CONSENT =
  'RECEIVED_SECURITY_OPERATIONAL_CONSENT';
export const receivedSecurityOperationalConsent = (consent) => ({
  type: RECEIVED_SECURITY_OPERATIONAL_CONSENT,
  consent
});

export const ERROR_SECURITY_OPERATIONAL_CONSENT =
  'ERROR_SECURITY_OPERATIONAL_CONSENT';
export const errorSecurityOperationalConsent = () => ({
  type: ERROR_SECURITY_OPERATIONAL_CONSENT
});

export const REQUESTED_SHORT_CODE_DEACTIVATION_REASON =
  'REQUESTED_SHORT_CODE_DEACTIVATION_REASON';
export const requestedShortCodeDeactivationReason = () => ({
  type: REQUESTED_SHORT_CODE_DEACTIVATION_REASON
});

export const RECEIVED_SHORT_CODE_DEACTIVATION_REASON =
  'RECEIVED_SHORT_CODE_DEACTIVATION_REASON';
export const receivedShortCodeDeactivationReason = (reason) => ({
  type: RECEIVED_SHORT_CODE_DEACTIVATION_REASON,
  reason
});

export const ERROR_SHORT_CODE_DEACTIVATION_REASON =
  'ERROR_SHORT_CODE_DEACTIVATION_REASON';
export const errorShortCodeDeactivationReason = () => ({
  type: ERROR_SHORT_CODE_DEACTIVATION_REASON
});

export const UPDATE_ALERTS_AND_NOTIFICATIONS_EMAIL =
  'UPDATE_ALERTS_AND_NOTIFICATIONS_EMAIL';
export const updateAlertsAndNotificationsEmail = (email) => ({
  type: UPDATE_ALERTS_AND_NOTIFICATIONS_EMAIL,
  email
});

export const UPDATE_ALERTS_AND_NOTIFICATIONS_PHONE =
  'UPDATE_ALERTS_AND_NOTIFICATIONS_PHONE';
export const updateAlertsAndNotificationsPhone = (phone) => ({
  type: UPDATE_ALERTS_AND_NOTIFICATIONS_PHONE,
  phone
});

export const RECEIVED_ALERTS_AND_NOTIFICATIONS =
  'RECEIVED_ALERTS_AND_NOTIFICATIONS';
export const receivedAlertsAndNotifications = (alertsAndNotifications) => ({
  type: RECEIVED_ALERTS_AND_NOTIFICATIONS,
  alertsAndNotifications
});

export const REQUESTED_ALERTS_AND_NOTIFICATIONS =
  'REQUESTED_ALERTS_AND_NOTIFICATIONS';
export const requestedAlertsAndNotifications = () => ({
  type: REQUESTED_ALERTS_AND_NOTIFICATIONS
});

export const ERROR_ALERTS_AND_NOTIFICATIONS = 'ERROR_ALERTS_AND_NOTIFICATIONS';
export const errorAlertsAndNotifications = () => ({
  type: ERROR_ALERTS_AND_NOTIFICATIONS
});

export const REQUESTED_UPDATE_ALERTS_AND_NOTIFICATIONS =
  'REQUESTED_UPDATE_ALERTS_AND_NOTIFICATIONS';
export const requestedUpdateAlertsAndNotifications = () => ({
  type: REQUESTED_UPDATE_ALERTS_AND_NOTIFICATIONS
});

export const RECEIVED_UPDATE_ALERTS_AND_NOTIFICATIONS =
  'RECEIVED_UPDATE_ALERTS_AND_NOTIFICATIONS';
export const receivedUpdateAlertsAndNotifications = () => ({
  type: RECEIVED_UPDATE_ALERTS_AND_NOTIFICATIONS
});

export const ERROR_UPDATE_ALERTS_AND_NOTIFICATIONS =
  'ERROR_UPDATE_ALERTS_AND_NOTIFICATIONS';
export const errorUpdateAlertsAndNotifications = () => ({
  type: ERROR_UPDATE_ALERTS_AND_NOTIFICATIONS
});

export const REQUESTED_VERIFY_SMS_ACTIVATION_CODE =
  'REQUESTED_VERIFY_SMS_ACTIVATION_CODE';
export const requestedVerifySmsActivationCode = () => ({
  type: REQUESTED_VERIFY_SMS_ACTIVATION_CODE
});

export const RECEIVED_VERIFY_SMS_ACTIVATION_CODE =
  'RECEIVED_VERIFY_SMS_ACTIVATION_CODE';
export const receivedVerifySmsActivationCode = () => ({
  type: RECEIVED_VERIFY_SMS_ACTIVATION_CODE
});

export const ERROR_VERIFY_SMS_ACTIVATION_CODE =
  'ERROR_VERIFY_SMS_ACTIVATION_CODE';
export const errorVerifySmsActivationCode = () => ({
  type: ERROR_VERIFY_SMS_ACTIVATION_CODE
});

export const REQUESTED_SUBMIT_SMS_ACTIVATION =
  'REQUESTED_SUBMIT_SMS_ACTIVATION';
export const requestedSubmitSmsActivation = () => ({
  type: REQUESTED_SUBMIT_SMS_ACTIVATION
});

export const RECEIVED_SUBMIT_SMS_ACTIVATION = 'RECEIVED_SUBMIT_SMS_ACTIVATION';
export const receivedSubmitSmsActivation = () => ({
  type: RECEIVED_SUBMIT_SMS_ACTIVATION
});

export const ERROR_SUBMIT_SMS_ACTIVATION = 'ERROR_SUBMIT_SMS_ACTIVATION';
export const errorSubmitSmsActivation = () => ({
  type: ERROR_SUBMIT_SMS_ACTIVATION
});

export const REQUESTED_ACTIVATED_FOR_TEXT_ALERTS =
  'REQUESTED_ACTIVATED_FOR_TEXT_ALERTS';
export const requestedActivatedForTextAlerts = () => ({
  type: REQUESTED_ACTIVATED_FOR_TEXT_ALERTS
});

export const RECEIVED_ACTIVATED_FOR_TEXT_ALERTS =
  'RECEIVED_ACTIVATED_FOR_TEXT_ALERTS';
export const receivedActivatedForTextAlerts = (isRegistered) => ({
  type: RECEIVED_ACTIVATED_FOR_TEXT_ALERTS,
  isRegistered
});

export const ERROR_ACTIVATED_FOR_TEXT_ALERTS =
  'ERROR_ACTIVATED_FOR_TEXT_ALERTS';
export const errorActivatedForTextAlerts = () => ({
  type: ERROR_ACTIVATED_FOR_TEXT_ALERTS
});

export const UPDATE_ALERT_OPTIONS = 'UPDATE_ALERT_OPTIONS';
export const updateAlertOptions = (field, selection) => ({
  type: UPDATE_ALERT_OPTIONS,
  field,
  selection
});

export const REQUESTED_SEND_SMS_ACTIVATION_CODE =
  'REQUESTED_SEND_SMS_ACTIVATION_CODE';
export const requestedSendSmsActivationCode = () => ({
  type: REQUESTED_SEND_SMS_ACTIVATION_CODE
});

export const RECEIVED_SEND_SMS_ACTIVATION_CODE =
  'RECEIVED_SEND_SMS_ACTIVATION_CODE';
export const receivedSendSmsActivationCode = () => ({
  type: RECEIVED_SEND_SMS_ACTIVATION_CODE
});

export const ERROR_SEND_SMS_ACTIVATION_CODE = 'ERROR_SEND_SMS_ACTIVATION_CODE';
export const errorSendSmsActivationCode = () => ({
  type: ERROR_SEND_SMS_ACTIVATION_CODE
});

export const REQUESTED_MOBILE_CARRIERS = 'REQUESTED_MOBILE_CARRIERS';
export const requestedMobileCarriers = () => ({
  type: REQUESTED_MOBILE_CARRIERS
});

export const RECEIVED_MOBILE_CARRIERS = 'RECEIVED_MOBILE_CARRIERS';
export const receivedMobileCarriers = (carriers) => ({
  type: RECEIVED_MOBILE_CARRIERS,
  carriers
});

export const ERROR_MOBILE_CARRIERS = 'ERROR_MOBILE_CARRIERS';
export const errorMobileCarriers = () => ({
  type: ERROR_MOBILE_CARRIERS
});
